import { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface UIState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  sophiaOpen: boolean;
  setSophiaOpen: (v: boolean) => void;
  toggleSophia: () => void;
}

const Ctx = createContext<UIState>({
  sidebarCollapsed: false, toggleSidebar: () => {},
  sophiaOpen: true, setSophiaOpen: () => {}, toggleSophia: () => {},
});

const KEY_SIDEBAR = "platform-v2:sidebar-collapsed";
const KEY_SOPHIA = "platform-v2:sophia-open";

export function UIStateProvider({ children }: { children: ReactNode }) {
  const [sidebarCollapsed, setSidebar] = useState(() => localStorage.getItem(KEY_SIDEBAR) === "1");
  // Sophia default open on lg+, closed on smaller — read once from localStorage or window width
  const [sophiaOpen, setSophiaOpen] = useState(() => {
    const stored = localStorage.getItem(KEY_SOPHIA);
    if (stored !== null) return stored === "1";
    return typeof window !== "undefined" ? window.innerWidth >= 900 : true;
  });

  useEffect(() => { localStorage.setItem(KEY_SIDEBAR, sidebarCollapsed ? "1" : "0"); }, [sidebarCollapsed]);
  useEffect(() => { localStorage.setItem(KEY_SOPHIA, sophiaOpen ? "1" : "0"); }, [sophiaOpen]);

  return (
    <Ctx.Provider
      value={{
        sidebarCollapsed,
        toggleSidebar: () => setSidebar((s) => !s),
        sophiaOpen,
        setSophiaOpen,
        toggleSophia: () => setSophiaOpen((s) => !s),
      }}
    >
      {children}
    </Ctx.Provider>
  );
}

export function useUIState() {
  return useContext(Ctx);
}
